import { createFileRoute } from '@tanstack/react-router';
import { CreateCardPage } from '../components/pages/CreateCardPage/CreateCardPage';
import { OwnerVerificationWrapper } from '../components/pages/SettingsPage/OwnerVerificationWrapper';

export const Route = createFileRoute('/account/cards_/create')({
  component: () => (
    <OwnerVerificationWrapper>
      <CreateCardPage />
    </OwnerVerificationWrapper>
  ),
});
